import { immerable } from 'immer'
import { v4 as uuidv4 } from 'uuid'
import { BehaviourSettingsEnum } from '~/config/constants/editorSettings'
import { EDITOR_MAIN_SETTINGS_MENU_ITEMS } from '~/config/constants/mainView'


export default class TimelineLayer {

  [immerable] = true

  constructor(data = {}) {
    const behaviourSettings = JSON.parse(localStorage.getItem(EDITOR_MAIN_SETTINGS_MENU_ITEMS.BEHAVIOUR_SETTINGS) || '{}')
    const {
      id = uuidv4(),
      name = '',
      muted = behaviourSettings?.[
        BehaviourSettingsEnum.muteAudioAtCreatedLayers
      ] ?? __CFG__.BEHAVIOUR_SETTINGS.MUTE_AUDIO_AT_CREATED_LAYERS,
      visible = true,
    } = data

    this._id = id
    this._name = name
    this._muted = muted
    this._visible = visible
  }

  /**
   * @returns {number}
   */
  get id() {
    return this._id
  }

  /**
  * @param {string} newId
  */
  set id(newId) {
    this._id = newId
  }

  /**
   * @returns {string}
   */
  get name() {
    return this._name
  }

  // ---

  /**
   * @returns {boolean}
   */
  get muted() {
    return this._muted
  }

  /**
   * @param {boolean} muted
   */
  set muted(muted) {
    this._muted = muted
  }

  // ---

  /**
   * @returns {boolean}
   */
  get visible() {
    return this._visible
  }

  /**
   * @param {boolean} visible
   */
  set visible(visible) {
    this._visible = visible
  }

}
